var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#4D4D4D",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.3,
    cy: 50.5,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.7,
    cy: 86,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2,39.9L97.2,39.9c-2.3-1-5.1,0.1-6.1,2.4l-5.9,13.9c-1.1-0.3-2.4-0.3-3.5,0.2c-1.3,0.5-2.4,1.6-2.9,2.9l-3.1,7.4   c-0.6,1.3-0.6,2.8,0,4.1c0.5,1.1,1.3,2,2.3,2.6l-5.9,13.9c-0.5,1.1-0.5,2.4,0,3.5c0.5,1.1,1.3,2,2.5,2.5c0.6,0.2,1.2,0.4,1.8,0.4   c1.8,0,3.5-1.1,4.3-2.8L86.5,77c0.6,0.2,1.2,0.4,1.8,0.4c2.1,0,4.1-1.2,4.9-3.3l3.1-7.4c1.1-2.6-0.1-5.7-2.6-6.9L99.6,46   C100.6,43.7,99.5,40.9,97.2,39.9z M78.3,89.8c-0.4,1.1-1.7,1.5-2.7,1.1c-0.5-0.2-0.9-0.6-1.1-1.1c-0.2-0.5-0.2-1.1,0-1.6l5.9-13.8   l3.8,1.6L78.3,89.8z M94,65.7l-3.1,7.4c-0.6,1.4-2.2,2.1-3.7,1.5l-7.7-3.3c-0.7-0.3-1.2-0.8-1.5-1.5c-0.3-0.7-0.3-1.5,0-2.1   l3.1-7.4c0.3-0.7,0.8-1.2,1.5-1.5c0.7-0.3,1.5-0.3,2.1,0l7.7,3.3C94,62.7,94.6,64.3,94,65.7z M97.3,45l-5.9,13.8l-3.8-1.6l5.9-13.8   c0.3-0.8,1.1-1.3,1.9-1.3c0.3,0,0.5,0.1,0.8,0.2C97.2,42.7,97.7,43.9,97.3,45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3,50.3L70.6,5l-26.9,8.8L49,30.1H5.3c-2.9,0-5.3,2.4-5.3,5.3v28.1c0,2.9,2.4,5.3,5.3,5.3h25.4v17.2c0,4.4,3.6,8,8,8   h15.9c4.4,0,8-3.6,8-8V57.7L85.3,50.3z M82.1,48.7L60,55.9l-1.5-4.7L80.6,44L82.1,48.7z M69,8.2l10.8,33.3l-22.1,7.2L46.9,15.4   L69,8.2z M30.7,47.5v18.9H5.3c-1.5,0-2.8-1.3-2.8-2.8V35.5c0-1.5,1.3-2.8,2.8-2.8h44.5l2.2,6.7H38.8C34.3,39.4,30.7,43,30.7,47.5z    M60.1,86.1c0,3-2.5,5.5-5.5,5.5H38.8c-3,0-5.5-2.5-5.5-5.5V47.5c0-3,2.5-5.5,5.5-5.5h14.1l5.6,17.1l1.7-0.6V86.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.71919a2e89e4a0c904b66992457e66d9.svg";
export { ForwardRef as ReactComponent };